import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
} from '@mui/material';

import { Context } from '../context/DataContext';
import PhotoField from '../components/form/PhotoField';
import { getImageFileName, dataURItoBlob } from '../utils';
import { useNonJsonDataGetter } from '../hooks/useDataGetter';

const UploadPhotosPage = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({});
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const { state, uploadUserPic, resetDataContext } = React.useContext(Context);
  const {
    customerInfo: { orderId },
  } = state;

  // getGuaranteeBook first
  useNonJsonDataGetter(
    `${process.env.REACT_APP_ACEMUSE_API_URL}/getGuaranteeBook/${orderId}`
  );

  const handlePhotoChange = (prop) => (dataURL) =>
    setValues({
      ...values,
      [prop]: dataURL,
    });

  return (
    <Box sx={{ textAlign: 'center', px: 3, pb: 6 }}>
      <Typography variant='h4' sx={{ my: 2 }}>
        照片上傳
      </Typography>
      <Box>
        <Typography variant='h6' sx={{ my: 2 }}>
          {`訂單號碼：${orderId}`}
        </Typography>
        <PhotoField
          label='手機正面'
          placeholder={<p>手機正面</p>}
          onChange={handlePhotoChange('phoneFront')}
        />
        <PhotoField
          label='手機反面'
          placeholder={<p>手機反面</p>}
          onChange={handlePhotoChange('phoneBack')}
        />
        <PhotoField
          label='身分證正面'
          watermark='限行動裝置保險使用'
          placeholder={<p>身分證正面</p>}
          onChange={handlePhotoChange('idCardFront')}
        />
        <PhotoField
          label='身分證反面'
          watermark='限行動裝置保險使用'
          placeholder={<p>身分證反面</p>}
          onChange={handlePhotoChange('idCardBack')}
        />
        {errorMsg ? (
          <Typography variant='h6' sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
        <Button
          variant='contained'
          disabled={loading}
          sx={{ width: 168 }}
          onClick={() => {
            const { idCardFront, idCardBack, phoneFront, phoneBack } = values;

            if (!idCardFront || !idCardBack || !phoneFront || !phoneBack) {
              setErrorMsg('請上傳照片');
            } else {
              setLoading(true);
              const idCardFrontName = getImageFileName() + '.jpg';
              const idCardBackName = getImageFileName() + '.jpg';
              const phoneFrontName = getImageFileName() + '.jpg';
              const phoneBackName = getImageFileName() + '.jpg';

              uploadUserPic(
                {
                  orderId,
                  idCardFront: new File(
                    [dataURItoBlob(idCardFront)],
                    idCardFrontName
                  ),
                  idCardFrontName,
                  idCardBack: new File(
                    [dataURItoBlob(idCardBack)],
                    idCardBackName
                  ),
                  idCardBackName,
                  phoneFront: new File(
                    [dataURItoBlob(phoneFront)],
                    phoneFrontName
                  ),
                  phoneFrontName,
                  phoneBack: new File(
                    [dataURItoBlob(phoneBack)],
                    phoneBackName
                  ),
                  phoneBackName,
                },
                ({ responseCode, responseMsg }) => {
                  setLoading(false);
                  if (responseCode === '000') {
                    resetDataContext({}, () => {
                      navigate('/order-completed');
                    });
                  } else {
                    setErrorMsg(responseMsg);
                  }
                }
              );
            }
          }}
        >
          下一步
        </Button>
        <Backdrop
          open={loading}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
          <Typography variant='h6' sx={{ my: 2, color: '#9DDCFF' }}>
            上傳中...
          </Typography>
        </Backdrop>
      </Box>
    </Box>
  );
};

export default UploadPhotosPage;
